import { patchState, signalStoreFeature, withMethods, withState } from '@ngrx/signals';
import { WSError } from '../dashboard.interfaces';

export const useWsStatus = () =>
  signalStoreFeature(
    withState({
      wsError: undefined as WSError | undefined,
    }),
    withMethods(store => {
      const setWSError = (wsError: WSError) => patchState(store, { wsError });

      const resetWSError = () => patchState(store, { wsError: undefined });

      return { setWSError, resetWSError };
    }),
  );
